import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslationsGuard } from '@ui/legacy-lib';
import { PropertiesComponent } from './screens/properties/properties.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/properties'
  },
  {
    path: 'properties',
    canActivate: [TranslationsGuard],
    component: PropertiesComponent
  },
  {
    path: '**',
    redirectTo: '/properties'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRouterModule {}
